import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import moment from 'moment';
import clsx from 'clsx';
import { Card } from '../../../components/Card';
import { Button } from '../../../components/Button';
import { Product } from '../../../data/Product';

type ProductCardProps = {
    onClick: (product: Product) => void,
    product: Product,
};

ProductCard.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        width: '100%',
        padding: theme.spacing(1),
    },
    button: {
        width: '100%',
    },
    fieldContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    field: {

    },
    label: {

    },
    value: {
        padding: theme.spacing(1, 0),
        fontSize: 20,
    },
    warning: {
        color: theme.palette.error.main,
    },
}));

function ProductCard(props: ProductCardProps): React.ReactElement {
    const {
        onClick,
        product,
    } = props;
    const classes = useStyle();

    function isExpire() {
        return moment(moment().format('YYYY-MM-DD 00:00:00')).unix() >= moment(product.date_next).unix();
    }

    return (
        <div className={classes.root}>
            <Card>
                <div className={classes.fieldContainer}>
                    <div className={classes.field}>
                        <div className={classes.label}>產品型號</div>
                        <div className={classes.value}>{product.product_model_id}</div>
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>前次出貨日</div>
                        <div className={classes.value}>{product.date_last}</div>
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>產品序號</div>
                        <div className={classes.value}>{product.sn_code}</div>
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>建議下次保養日</div>
                        <div className={clsx(classes.value, { [classes.warning]: isExpire() })}>{product.date_next}</div>
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>上機位置</div>
                        <div className={classes.value}>{product.location}</div>
                    </div>
                    <div className={classes.field}>
                        <div className={classes.label}>保固到期日</div>
                        <div className={classes.value}>{product.warranty_expiration}</div>
                    </div>
                </div>
                <Button onClick={() => onClick(product)}>
                    <span>立刻送修</span>
                    <Icon icon="wrench" size="lg" style={{ marginLeft: 8 }} />
                </Button>
            </Card>
        </div>
    );
}

export { ProductCard };
